import React from 'react';

import { pathChildrenMap } from '../../services/router/AppRouter';
import { statementDetailsRoutes } from '../../services/router/app-routes/statements-routes';
import { IScreenComponentProps } from '../component-props.model';

export const StatementHome = ({ state, parentRoute }: IScreenComponentProps): JSX.Element => {
  return <>{pathChildrenMap(statementDetailsRoutes.children, parentRoute, state)}</>;
};
